import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { finalize } from "rxjs";
import { Router } from "@angular/router";
import { LoginService } from "../service/login.service";
import { ConsentService, ConfigField } from '../service/consent.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  isLoading = false;
  loginError: string | null = null;
  showPassword = false;
  group = '';

  primaryKeyField: ConfigField | null = null;
  passwordField: ConfigField | null = null;

  constructor(
    private loginService: LoginService,
    private consentService: ConsentService,
    private router: Router
  ) {}

  ngOnInit() {
    this.consentService.getFormFieldsObservable().subscribe(fields => {
      if (fields && fields.length) {
        this.findSpecialFields(fields);
        this.initForm();
      }
    });
    this.consentService.getGroupObservable().subscribe(group => {
      if (group) {
        this.group = group;
      }
    })
  }

  private findSpecialFields(fields: ConfigField[]) {
    this.primaryKeyField = fields.find(field => field.primaryKey === "true") || null;
    this.passwordField = fields.find(field => field.password === "true") || null;
  }

  private initForm() {
    const formControls: { [key: string]: FormControl } = {};

    if (this.primaryKeyField) {
      formControls['username'] = new FormControl('', Validators.required);
    }

    if (this.passwordField) {
      formControls['password'] = new FormControl('', [
        Validators.required,
      ]);
    }

    this.loginForm = new FormGroup(formControls);
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.loginForm.get(fieldName);
    return field ? (field.invalid && (field.dirty || field.touched)) : false;
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  login() {
    if (this.loginForm.invalid) {
      Object.values(this.loginForm.controls).forEach(control => control.markAsTouched());
      return;
    }

    this.isLoading = true;
    this.loginError = null;

    this.loginService.login(this.loginForm.value, this.group)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: response => {
          this.router.navigate([this.group + '/consentement']);
        },
        error: error => this.handleError(error.status)
      });
  }

  private handleError(statusCode: number) {
    switch (statusCode) {
      case 401:
      case 404:
        this.loginError = "Identifiant ou mot de passe incorrect, Assurez-vous de reprendre les données présentes sur votre courrier.";
        break;
      case 403:
        this.loginError = "Accès non autorisé";
        break;
      default:
        this.loginError = "Une erreur est survenue lors de la connexion";
        break;
    }
  }
}
